//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setColumnFormatter } from '@/utils/util';
import SimpleTable from '@/components/simpleTable';
// import {refFieldQuery} from '@/api/crud'

export default {
  components: {
    SimpleTable: SimpleTable
  },
  props: {
    entity: String,
    refField: String,
    extraFilter: String,
    // 查询条件
    tableHeight: {
      type: String,
      default: '480px'
    }
  },
  name: 'ReferenceSearchTable',
  data: function data() {
    return {
      idField: null,
      nameField: null,
      queryText: '',
      columns: [],
      tableData: [],
      page: {
        pageNo: 1,
        limit: 15,
        sizes: [15, 20, 30],
        total: 0
      }
    };
  },
  mounted: function mounted() {
    // TODO  调接口
    // this.loadTableTable()
  },
  methods: {
    // 改变分页大小处理
    handleSizeChange: function handleSizeChange(val) {
      this.page.limit = val;
      this.loadTableTable();
    },
    // 翻页处理
    handleCurrentChange: function handleCurrentChange(val) {
      this.page.pageNo = val;
      this.loadTableTable();
    },
    loadTableTable: function loadTableTable() {
      var _this = this;
      refFieldQuery(this.entity, this.refField, this.page.pageNo, this.page.limit, this.queryText, this.extraFilter).then(function (res) {
        if (res.error != null) {
          _this.$message({
            message: res.error,
            type: 'error'
          });
        } else {
          _this.idField = res.data.idFieldName;
          _this.nameField = res.data.nameFieldName;
          var columnList = res.data.columnList;
          columnList.forEach(function (cl) {
            setColumnFormatter(cl);
          });
          _this.columns = columnList;
          _this.tableData = res.data.dataList;
          _this.page.total = res.data.pagination.total;
        }
      }).catch(function (res) {
        _this.$message({
          message: res.error,
          type: 'error'
        });
      });
    },
    selectRecord: function selectRecord(row) {
      this.$emit('recordSelected', {
        id: row[this.idField],
        label: row[this.nameField]
      }, row);
    },
    doSearch: function doSearch() {
      this.loadTableTable();
    },
    cancelSearch: function cancelSearch() {
      this.loadTableTable();
    }
  }
};